var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.showModalCamadas
        ? _c("app-modal-cruzamento-camada", {
            attrs: { cruzamento: _vm.cruzamentoCamada.json },
            on: { close: _vm.visualizarCruzamentoCamadas }
          })
        : _vm._e(),
      _c("app-divider", { attrs: { label: "Georreferenciamento" } }),
      _c(
        "div",
        { staticClass: "pad" },
        [
          _vm.localizacoes && _vm.localizacoes.length
            ? _c(
                "div",
                [
                  _c("app-resumo-mapa", {
                    key: _vm.mapaKey,
                    attrs: {
                      localizacoes: _vm.localizacoes,
                      "id-mapa": _vm.idMapa,
                      isVisualizarCadastro: true
                    }
                  }),
                  _vm.idProcesso
                    ? _c(
                        "div",
                        { staticClass: "btn" },
                        [
                          _c(
                            "el-button",
                            { on: { click: _vm.downloadShape } },
                            [
                              _c("i", { staticClass: "fal fa-download" }),
                              _vm._v("  Download do shapefile")
                            ]
                          ),
                          _vm.cruzamentoCamada
                            ? _c(
                                "el-button",
                                {
                                  on: { click: _vm.visualizarCruzamentoCamadas }
                                },
                                [
                                  _c("i", { staticClass: "fal fa-eye" }),
                                  _vm._v("  Visualizar cruzamentos")
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              )
            : _c(
                "div",
                [
                  _vm.geo.responsavel
                    ? _c(
                        "el-row",
                        { staticClass: "pad5" },
                        [
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Responsável:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(_vm.geo.responsavel.nome)
                                    )
                                )
                              ])
                            ])
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("Formação:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.geo.responsavel.formacao
                                      )
                                    )
                                )
                              ])
                            ])
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v("CREA ou RNP:")
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.geo.responsavel.creaRnp
                                      )
                                    )
                                )
                              ])
                            ])
                          ]),
                          _c("el-col", { attrs: { span: 12 } }, [
                            _c("p", [
                              _c("span", { staticClass: "label" }, [
                                _vm._v(
                                  "Código de credenciamento junto ao INCRA:"
                                )
                              ]),
                              _c("span", [
                                _vm._v(
                                  "  " +
                                    _vm._s(
                                      _vm.filterNull(
                                        _vm.geo.responsavel.codigoIncra
                                      )
                                    )
                                )
                              ])
                            ])
                          ])
                        ],
                        1
                      )
                    : _vm._e()
                ],
                1
              ),
          _vm.geo.documentos.length
            ? _c("app-resumo-documentos", {
                attrs: { documentos: _vm.geo.documentos }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7c2cb33f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c2cb33f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoGeo.vue
// module id = null
// module chunks = 